import React, { useState, useEffect, useRef } from 'react';
import SliderHeader from 'jd-library/SliderHeader';
import { connect } from 'react-redux';
import './photo-slider.scss';
import Button from 'jd-library/Button';
import historyHandler from 'jd-library/historyHandler';
import useInfiniteScroll from 'jd-library/useInfiniteScroll';
import SliderWrapper from "jd-library/SliderWrapper";
import { useHistory } from 'react-router-dom';
import { setRedirectedFrom, getVendorImages, setVendorImages, updateProductMedia, deleteVendorImages, formatGalleryImage, uploadMultipleImages, uploadAddEditMutlipleImages,productScoreUpdate, handleAIProductCreation } from '../../actions/products';
import { updateItemImage, resetItemInfo } from '../../actions/items';
import axios from 'axios';
import ImageViewUpload from '../../common/product-image/ImageViewUpload'
import FileSelector from '../../common/FileSelector';
import { getImagePath } from '../../common/productImageUtils.js';
import { uploadMultipleFile } from '../../common/productImageUtils'
import toastMessageActions from "jd-library/toastMessageActions";
import { getRouteChangeMessage as getToastMessage } from '../../utills';
import PhotoGallerySliders from './PhotoGallerySliders';
import {
    setJdPhotosData,
    setSelectedGalleryImages,
	toggleGalleryModal,
    togglePhotoSlider,
} from '../../actions/photosGallery';
import RevealAnimation from '../../common/transition/Animation'
import { showHideLoader } from '../../actions';
import {getProductData, getListingData,setSelectedType, addJdGalleryPhotos} from '../../actions/products'
import { addJdGalleryPhotosToProduct, uploadPhotoFromApp } from './photoSliderUtills'
import { dataArys } from '../listing/ProductScore/utils';
import { toggleUploadOptions, uploadImageFromLink } from '../../actions/upload-options';

const PhotoSlider = props => {
    const variantId = props.variantId;
    const productId = props.productId
    const directAddToProduct = !!productId;
    let history = useHistory();
    const selectedImages = props.selectedImages;
    const isJdPhotoSlider = props.isJdPhotoSlider;
    const currentPage = useRef(0);
    const fileSelector = useRef(null);
    const skipRoute = useRef(false);
    const photoSliderRef = useRef(null);
    const [apiCalled,updateApiCall] = useState(false);
    const [isScrolled, setScrolled] = useState(
		typeof document === 'object' && document.scrollingElement.scrollTop > 0
	)
    const [isScrolledmob, setScrolledmob] = useState(
		typeof document === 'object' && document.scrollingElement.scrollTop > 0
	)
    const {heading,noResultTxt} = props.displayOption || {};
    const scrollHandler = e => {
		setScrolled(e.target.scrollTop > 5);
        setScrolledmob(e.target.scrollTop > 5);
	};

    let isEnrich = false;

    useEffect(() => {
        const timer = setTimeout(() => {
            const sliderInstance = photoSliderRef.current?.sliderRef?.current;
            if (sliderInstance?.sliderContentRef?.current) {
                const sliderContainer = sliderInstance.sliderContentRef.current.parentElement;
                if (sliderContainer) {
                    const firstFocusable = sliderContainer.querySelector('[tabindex="0"], button:not([disabled])');
                    if (firstFocusable) firstFocusable.focus();
                }
            }
        }, 350);
        return () => clearTimeout(timer);
    }, []);

    useEffect(()=>{
        if(!props.supplierId && !props?.session?.user?.loggedUser?.subType === 'CONTRACTORV4'){
            history.replace("/products")
        }

        if (props?.session?.user?.loggedUser?.subType === 'CONTRACTORV4') {
            isEnrich = true;
        }

        props.getVendorImages({supplierId: props.supplierId, isJdPhotoSlider, token: props.session.token,productId: props.productId, isEnrich: isEnrich,isAISlider: props.isAISlider,keywordId: props.keywordId,curImageUrl: props.curVariantImageUrl});
        if(props.redirectedFrom == 'photos'){
            props.redirectedFrom({});
        }
        let toastmsg = getToastMessage();
		if(toastmsg){
			props.showToastMessage({
				message: toastmsg.message,
				showToastMessage: true,
				animationTime :5000,
                bottom: props.session.hasGlassFooter ? '80px' : '0px'
			})
        }
        if(isJdPhotoSlider){
            props.togglePhotoSlider({
                isJdPhotoSlider: true,
                selectPhotoSlider: true,
            })
        }
        return () => {
            props.togglePhotoSlider({
                isJdPhotoSlider: false,
                displayOption: {},
                isAISlider: false
            })
            props.setJdPhotosData({});
        }
    }, [])

    useEffect(() => {
        if(Array.isArray(props.vendorImages)) {
            updateApiCall(true);
        } 
    },[props.vendorImages])

    const loadDataOnInfiniteScroll = () => {
        let url = `/vendorapis/products/image/getAllImagesForSupplier?supplierId=${props.supplierId}&pageNo=${currentPage.current+1}`;
        if(isJdPhotoSlider) {
            url = `/marketplace/static/php/web/b2bWebsite.php?action=getJdGalleryImages`
        }
        if (isEnrich) {
            url += '&forEnrich=true';
        } else {
            if (isJdPhotoSlider) {
                url += `&token=${props.session.token}`;
            }
        }

        axios.get(url)
        .then((res)=>{
            if(res.data.data.length){
                let newImgArr = res.data.data.map(formatGalleryImage);
                props.setVendorImages([...props.vendorImages, ...newImgArr], isJdPhotoSlider);
                currentPage.current = currentPage.current + 1;
                setIsFetching(false);
            }
        })
    }

    const [isFetching, setIsFetching] = useInfiniteScroll({
		loadMoreCB: loadDataOnInfiniteScroll,
		threshold: 300,
		useWindow: true
    });

    const combinePhotos = (productData = {},selectedProductType='product',fromAI = false) => {
        if(props.isJdPhotoSlider) {
            historyHandler.closeAll();
        } else {
            historyHandler.closeMultiSlider(2);
        }
        setTimeout(()=>{
            if(props.session.source == 'webstore'){
                props.resetItemInfo();
                for(let i=selectedImages.length-1;i>=0;i--){
                    props.updateItemImage(props.vendorImages[selectedImages[i]]);
                }
                props.setRedirectedFrom({redirectedFrom: 'photos'});
                props.setSelectedGalleryImages([]);
                history.push('/add-item');
            }else{
                if(selectedProductType == 'product' && fromAI) {
                    let imgArr = props.vendorImages.filter((cur,index)=>selectedImages.includes(index));
                    props.handleAIProductCreation({
                        imageArr: imgArr,
                        fromPhotoSlider: true,
                    })
                    return;
                }
                if(props.isMobile){
                    if(productData.generic_p_id) {
                        history.push(`/products/${props.session.viaOmni? 'edit-omni' : 'edit'}/${productData.generic_p_id}?isGenericProduct=true`);
                    } else {
                        history.push(`/products/${props.session.viaOmni?'add-omni' :'add'}?selectedProductType=${selectedProductType}&fromPhotos=true${props.isJdPhotoSlider ? '&fromJdPhotoSlider=true' : ''}`);
                    }
                }else{
                    const options = {
                        productId : 'ADD_PRODUCT',
                        viaSuggested: true
                    };
                    if (productData.generic_p_id){
                        options.productId = productData.generic_p_id;
                        options.isTemplateProduct = true;
                    }
                    !props.isJdPhotoSlider && props.getProductData(options);
                }
                let imgArr = props.vendorImages.filter((cur,index)=>selectedImages.includes(index));
                if(props.isJdPhotoSlider) {
                    props.toggleUploadOptions({
                        show: false,
                        data: {
                            productId: 'ADD_PRODUCT'
                        }
                    });
                    props.showHideLoader({
                        showLoader: true
                    })
                    props.getProductData({
                        productId: 'ADD_PRODUCT',
                        viaSuggested: true
                    })
                }
                for(let i=0;i<imgArr.length;i++){
                    if(!imgArr[i].base64Url){
                        imgArr[i].finalImageSrc = imgArr[i].finalImageSrc ? imgArr[i].finalImageSrc : getImagePath(imgArr[i].imageUrl)
                        imgArr[i].imgURL = imgArr[i].imgURL ? imgArr[i].imgURL : imgArr[i].imageUrl
                        if(props.isJdPhotoSlider && imgArr[i].imgURL.includes('content.jdmagicbox')) {
                                props.uploadImageFromLink({
                                link: imgArr[i].imgURL,
                                isAddProductPage: true,
                            },isSuccess => {
                                if(isSuccess) {
                                    props.showHideLoader({
                                        showLoader: false
                                    })
                                }
                            })
                        }else {
                            props.updateProductMedia({
                                imageUrl: imgArr[i],
                                editProductId: "ADD_PRODUCT",
                                source: "b2b",
                                imgIndex: i,
                                isAddEditProduct: true
                            })
                        }
                    }
                }
                if (!productData.generic_p_id) {
                    props.setSelectedGalleryImages([]);
                }
            }
        },100)
        props.setSelectedType({
            selectedCategoryType: selectedProductType
        })
    }

    const deletePhotos = (fromModal) => {
        const imagesToDelete = [];
        if(!props.isJdPhotoSlider){
            props.vendorImages.filter((cur, index) => {
                const isDeleted = selectedImages.includes(index);
                if(isDeleted){
                    imagesToDelete.push(cur.galleryId);
                }
                return !isDeleted
            })
        }
        if(fromModal){
            historyHandler.closeCurrent() //Close Modal
            props.showToastMessage({
				message: `${selectedImages.length > 1 ? selectedImages.length+' Photos' : 'Photo'} Deleted Successfully`,
                showToastMessage: true,
                type: 'info',
				animationTime :5000,
                bottom: props.session.hasGlassFooter ? '80px' : '0px'
			})
        }
        setTimeout(() => {
            props.setSelectedGalleryImages([])
        }, 300) // wait for modals to close
        props.deleteVendorImages({
            imagesToDelete,
            supplierId: props.supplierId
        })
        const remainingVendorImages = props.vendorImages.length - imagesToDelete.length;
        if(!remainingVendorImages && !props.isJdPhotoSlider && !fromModal) {
            skipRoute.current = true;
        } else {
            skipRoute.current = false;
        }
        return remainingVendorImages
    }

    const selectPhoto = (isSelected, index, startUploadFlow) => {
        //index is the index of image in imageArray
        let tempArr = [...selectedImages];
        if(isSelected){
            tempArr.splice(tempArr.indexOf(index),1)
        }else{
            tempArr.push(index)
            tempArr.sort(function(a, b){return b - a});
        }
        props.setSelectedGalleryImages(tempArr);
        if(!directAddToProduct && startUploadFlow && !isSelected && tempArr.length == 1){
            props.toggleGalleryModal({
                addModal: {
                    show: true
                }
            })
        }
    }

    const getFooterHtml = () => {
        if(selectedImages.length){
            return(
                <div class={`footer-btn-holder ${props.hasGlassFooter ? ' ublc-photo-slider-footer-btn' : ''}`} >
                    <Button
                        onClick={()=>{
                            if(selectedImages.length > 40){
                                props.showToastMessage({
                                    showToastMessage: true,
                                    message: 'Max 40 Images are Allowed in One Product/Service. Please Unselect Few Photos before Combining them into a Single Product/Service',
                                    duration: 5000,
                                    className: !props.isMobile ? 'large-toast' : '',
                                    longToastMessage: true,
                                    type: 'error',

                                });
                                return;
                            }
                            if(!directAddToProduct) {
                                props.toggleGalleryModal({
                                    addModal: {
                                        show: true
                                    }
                                })
                            } else{
                                if((props.directAddToProduct && props.onSave) && productId){
                                    if(props.imageUrlArr?.length){
                                        if(props.imageUrlArr.length + selectedImages.length > 40){
                                            props.showToastMessage({
                                                showToastMessage: true,
                                                message: 'Max 40 Images are Allowed in One Product/Service. Please Unselect Few Photos before Combining them into a Single Product/Service',
                                                duration: 5000,
                                                type:'info'
                                            });
                                            return;
                                        }
                                    }
                                    props.showHideLoader({
                                        showLoader: true
                                    })
                                    props.onSave({
                                        vendorImages: props.vendorImages,
                                        selectedImages,
                                        saveCB: () => {
                                            props.showHideLoader({
                                                showLoader: false
                                            })
                                        }
                                    });
                                    props.setSelectedGalleryImages([]);
                                    return;
                                }
                                props.showHideLoader({
                                    showLoader: true
                                })
                                let addJdGallery = props.isJdPhotoSlider ? props.addJdGalleryPhotos : props.addJdGalleryPhotosToProduct;
                                addJdGallery({
                                    token: props.session.token,
                                    source: props.session.source,
                                    productId,
                                    curImageUrl: props.curVariantImageUrl,
                                    vendorImages: props.vendorImages,
                                    selectedImages,
                                    fromListing: props.fromListing,
                                    isAddEditProduct: props.isAddEditProduct,
                                    isAddEditProductOmni: props.isAddEditProductOmni,
                                    cb: (type, imageUrlArr) => {
                                        if(type == 'maxImageToast') {
                                            props.showToastMessage({
                                                showToastMessage: true,
                                                message: 'Max 40 Images are Allowed in One Product. Please Unselect Few Photos before Combining them into a Single Product',
                                                duration: 5000,
                                                className: 'large-toast',
                                                type: 'info',
                                                bottom: props.session.hasGlassFooter ? '80px' : '0px'
                                            });
                                        } else {
                                            deletePhotos(false);
                                            props.showToastMessage({
                                                showToastMessage: true,
                                                message: `${selectedImages.length > 1 ? 'Photos' : 'Photo'} Added to ${props.selectedCategoryType && props.selectedCategoryType == 'service' ? 'Service': 'Product'} Successfully`,
                                                duration: 5000,
                                                type: 'info',
                                                bottom: props.session.hasGlassFooter ? '80px' : '0px'
                                            })
                                            if(!props.isJdPhotoSlider) {
                                                props.isAddEditProduct || props.isAddEditProductOmni ?
                                                props.uploadAddEditMutlipleImages({
                                                    productId,
                                                    imageUrlArr
                                                }): props.uploadMultipleImages({
                                                    productId,
                                                    imageUrlArr
                                                })
                                                if(productId != 'ADD_PRODUCT') {
                                                    props.getListingData({});
                                                }
                                            }
                                            setTimeout(() => {
                                                let params = new URLSearchParams(location.search.substring(1));
                                                let dummyAddProduct = params.get("dummyAddProduct");
                                                if(!props.dummyAddProduct && !dummyAddProduct){
                                                    historyHandler.closeCurrent();
                                                }else {
                                                    if(props.isMobile){
                                                        if(props.dummyAddProduct){
                                                            historyHandler.closeCurrent();
                                                        }
                                                        setTimeout(()=>{
                                                            history.push("/products/add?selectedProductType="+props.selectedCategoryType+"&fromPhotos=true");
                                                        },100);
                                                    }else{
                                                        props.getProductData({
                                                            productId : 'ADD_PRODUCT'
                                                        })
                                                    }
                                                }
                                                props.productScoreUpdate({ id: productId, score: 0, docId: props.userDocId })
                                            }, 500)
                                        }
                                        props.showHideLoader({
                                            showLoader: false
                                        })
                                    }
                                })
                            }
                        }}
                        block={true}
                        size='lg'
                    >
                        {
                            props.isVariant ?
                            `Add ${selectedImages.length>1 ? 'Images' : 'Image'} to Product`


                            : `Add ${selectedImages.length>1 ? 'Photos' : 'Photo'} To ${props?.session?.profileObject?.SingleLabelWithSpace}`



                        }

                    </Button>
                </div>
            )
        }else{
            return null;
        }
    }

    const uploadImage = (e) => {
        let tempArr = [...props.vendorImages];
        let toastShown = false;
        uploadMultipleFile({
            imageUrlArr: [],
            data: e.target.files,
            productId: '',
            imgUploadUrl: '/vendorapis/products/image/uploadProductImageForLibrary',
            updateImage: (res) => {
                if(res.uploaded && res.imgURL){
                    for(let i=tempArr.length-1;i>=0;i--){
                        if(tempArr[i].imgIndex == res.imgIndex){
                            tempArr[i] = {
                                actualPath: res.actualPath,
                                imageUrl: res.imgURL,
                                uploaded: res.uploaded,
                                finalImageSrc: getImagePath(res.imgURL),
                                galleryId: res.galleryId
                            }
                        }
                    }
                    props.setVendorImages([...tempArr], isJdPhotoSlider);
                    if(res.noOfFilesToUpload === 1 && !directAddToProduct){
                        props.toggleGalleryModal({
                            selectedImages:  [0],
                            addModal: {
                                show: true
                            }
                        })
                    }
                }else if(res.base64Url){
                    tempArr.push(res);
                    props.setVendorImages([...tempArr], isJdPhotoSlider);
                }
                //push the base64 image, replace with normal once done
                if(!toastShown){
                    props.showToastMessage({
                        showToastMessage: true,
                        message: `${res.noOfFilesToUpload > 1 ? res.noOfFilesToUpload+' Photos' : 'Photo'} Added Successfully`,
                        duration: 5000,
                        bottom: props.session.hasGlassFooter ? '80px' : '0px'
                    })
                    toastShown = true;
                }
            }
        })
    }

    const rightIcons = [{
        className: 'icon-trash',
        onClick: () => {
            props.toggleGalleryModal({
                deleteModal: {
                    show: true
                }
            })
        }
    }]

    const getPhotoSlider = () => {
        return(
        <>
            <div className={"photos-page "+(props.isMobile ? 'mobile-page' : 'web-page')+ (props.hasGlassFooter ? ' ublc-photo-slider-padding' : '')}>
                {!isJdPhotoSlider && !props.isVariant && !props.selectPhotoSlider? <SliderHeader
                    heading={heading || (isJdPhotoSlider ? 'Justdial Gallery' : 'Photos')}
                    leftIcons={[
                        {
                            className: props.session.source == 'webstore' ? 'icon-HDRback' : 'icon-hdrBackNew',
                            onClick: () => {
                                props.setSelectedGalleryImages([]);
                                history.goBack();
                            }
                        }
                    ]}
                    className='photos-slider-header'
                    rightIcons={selectedImages.length && !isJdPhotoSlider ? [...rightIcons] : undefined}
                    hasBorder={true}
                    raised = {isScrolledmob}
                />: ''}
                {apiCalled ? (((Array.isArray(props.vendorImages) && props.vendorImages?.length) || skipRoute.current) ?
                    <RevealAnimation>
                        <div className="photos-body" onScroll={(e) => { scrollHandler(e) }}>
                            {
                                props.vendorImages.map((item, index)=>{
                                    const isSelected = selectedImages.includes(index);
                                    return(
                                        <div
                                            className="photo-holder"
                                            tabIndex={0}
                                            role="checkbox"
                                            aria-checked={isSelected}
                                            aria-label={`Image ${index + 1}${isSelected ? ', selected' : ''}`}
                                            onKeyDown={e => {
                                                if (e.key === ' ' || e.key === 'Enter') {
                                                    e.preventDefault();
                                                    selectPhoto(isSelected, index);
                                                }
                                            }}
                                        >
                                            <ImageViewUpload
                                                imageUrlArr={[item]}
                                                showCheckBox={true}
                                                checkCB={()=>{selectPhoto(isSelected, index)}}
                                                tickStatus={isSelected}
                                                customCB={()=>{selectPhoto(isSelected, index, true)}}
                                                className={isSelected ? 'selected' : ''}
                                                onLongPress={()=>{selectPhoto(isSelected, index)}}
                                            />
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </RevealAnimation> :
                    <div className="no-photos">
                        <img src="https://image1.jdomni.in/jdomni_email/No_Orders_2010271823.png" />
                        <div className="title" dangerouslySetInnerHTML={{__html: noResultTxt ? noResultTxt : 'No Photos Found'}} />
                        {!isJdPhotoSlider ? <Button
                            children="Add Photos"
                            size="lg"
                            onClick={()=>{
                                if(window.jdInterface){
                                    uploadPhotoFromApp(props);
                                }else{
                                    fileSelector.current.triggerClick(true)
                                }
                            }}
                            className='button-class'
                        /> : null}
                        <FileSelector
                            ref={fileSelector}
                            onChange={uploadImage}
                        />
                    </div>) : null
                }
                {getFooterHtml()}
            </div>
            <PhotoGallerySliders
                deletePhotos={deletePhotos}
                combinePhotos={combinePhotos}
                isJdPhotoSlider={isJdPhotoSlider}
            />
        </>)
    }

    return(
        <>
        {!isJdPhotoSlider && !props.isVariant && !props.selectPhotoSlider ?
            getPhotoSlider() :
            <SliderWrapper
                ref={photoSliderRef}
                header={{
                    heading:heading || (isJdPhotoSlider ? 'Justdial Gallery' : 'Photos'),
                    leftIcons:[
                        {
                            className: props.session.source == 'webstore' ? 'icon-HDRback' : 'icon-hdrBackNew',
                            onClick: () => {
                                props.setSelectedGalleryImages([]);
                                history.goBack();
                            }
                        }
                    ],
                    className:'photos-slider-header',
                    rightIcons:selectedImages.length && !isJdPhotoSlider ? [...rightIcons] : [],
                    hasBorder: true,
                    raised: isScrolled
                }}
                onHidden={props.onHidden}
                enableHeader
                onScroll={(e) => { scrollHandler(e) }}
            >
                {getPhotoSlider()}
            </SliderWrapper>
        }
    </>
    )
}

const mapStateToProps = (state,props) => {
    const newProps = {
        ...props,
        isMobile: state.library.deviceData.isMobile,
        isIphone: state.library.deviceData.isIphone,
        selectedImages: state.photosGallery.selectedImages,
        vendorImages: state.products.vendorImages,
        supplierId: state.session.supplierId,
        variantId: state.photosGallery?.jdPhotosData?.variantId,
        productId: state.photosGallery?.jdPhotosData?.productId,
        curVariantImageUrl: state.photosGallery?.jdPhotosData?.curImageUrl || "",
        session: state.session,
        categoryType: state.photosGallery?.jdPhotosData?.categoryType,
        dummyAddProduct: state.photosGallery?.dummyAddProduct,
        selectedCategoryType: state.products.selectedCategoryType,
        user: state.session.user,
        isVariant: state.photosGallery.isVariant,
        fromListing: state.photosGallery.fromListing,
        isAddEditProduct: state.photosGallery.isAddEditProduct,
        isAddEditProductOmni: state.photosGallery.isAddEditProductOmni,
        onSave: state.photosGallery.onSave,
        directAddToProduct: state.photosGallery.directAddToProduct,
        imageUrlArr: state.photosGallery.imageUrlArr,
        selectPhotoSlider: state.photosGallery.selectPhotoSlider,
        userDocId : state.session.docId || 0,
        displayOption: state.photosGallery?.displayOption,
        isAISlider: state.photosGallery?.isAISlider,
        keywordId: state.photosGallery?.keywordId,
        hasGlassFooter: state.session.hasGlassFooter
    };
    const isJdPhotoSlider = props.isJdPhotoSlider || state.photosGallery.isJdPhotoSlider;
	if(isJdPhotoSlider) {
		newProps.isJdPhotoSlider = true;
		newProps.vendorImages = state.products.jdGalleryImages;
	}
    return newProps;
}

export default connect(mapStateToProps, {
    setRedirectedFrom,
    updateItemImage,
    setVendorImages,
    getVendorImages,
    deleteVendorImages,
    updateProductMedia,
    showToastMessage: toastMessageActions.showMessage,
    toggleGalleryModal,
    setSelectedGalleryImages,
    uploadMultipleImages,
    setJdPhotosData,
    getListingData,
    resetItemInfo,
    showHideLoader,
    togglePhotoSlider,
    getProductData,
    setSelectedType,
    uploadAddEditMutlipleImages,
    productScoreUpdate,
    addJdGalleryPhotosToProduct,
    addJdGalleryPhotos,
    uploadImageFromLink,
    toggleUploadOptions,
    showHideLoader,
    handleAIProductCreation
})(PhotoSlider)
